export default "__VITE_ASSET__D0G4aSTL__"